import { Component, Inject, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ConfirmDialogData {
    title?: string;
    body?: string;
    buttons: {
        confirm?: {
            text: string;
            class: string;
            disabled?: boolean; // Optional property to disable the button
        };
        cancel?: {
            text: string;
            class: string;
            disabled?: boolean; // Optional property to disable the button
        };
    };
}

@Component({
    selector: 'confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent {
    public buttonClick = false;

    public loading = false;

    @Output() onSubmit: EventEmitter<any> = new EventEmitter<any>();

    constructor(
        public dialogRef: MatDialogRef<ConfirmDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData,
    ) {}

    get title(): string {
        return this.data.title;
    }

    get body(): string {
        return this.data.body;
    }

    get cancelButton(): ConfirmDialogData['buttons']['cancel'] {
        return this.data?.buttons?.cancel;
    }

    get confirmButton(): ConfirmDialogData['buttons']['confirm'] {
        return this.data?.buttons?.confirm;
    }

    onNoClick(): void {
        this.cancel();
    }

    confirm(): void {
        this.onSubmit.emit(true);
    }

    cancel(): void {
        this.onSubmit.emit(false);
    }
}
